const REF_URL_COOKIE_NAME = "ref_url";
const REF_URL_COOKIE_DAYS = 15;

export const setCookie = ({ name, value, daysToLiveInDays = 365 }) => {
  const date = new Date();
  date.setTime(date.getTime() + daysToLiveInDays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + date.toUTCString();
  document.cookie = `${name}=${value}; ${expires}; path=/`;
};

export const deleteCookie = ({ name }) => {
  setCookie({ name, value: null, daysToLiveInDays: null });
};

export const getCookie = ({ name }) => {
  const cDecoded = decodeURIComponent(document.cookie);
  const cookieArray = cDecoded.split("; ");
  let result = null;

  cookieArray.forEach((ele) => {
    if (ele.indexOf(name) === 0) {
      result = ele.substring(name.length + 1);
    }
  });

  return result;
};

export const setRefUrlCookie = (refUrl) => {
  if (!refUrl) return;
  setCookie({
    name: REF_URL_COOKIE_NAME,
    value: refUrl,
    daysToLiveInDays: REF_URL_COOKIE_DAYS,
  });
};

export const getRefUrlCookie = () => {
  return getCookie({ name: REF_URL_COOKIE_NAME }) || null;
};

// Current page URL + ?ref= stored landing URL (for leads API reference_url).
export const getCurrentPageUrlWithRefFromCookie = () => {
  if (typeof window === "undefined") return null;
  const ref = getRefUrlCookie();
  const base = window.location.origin + window.location.pathname;
  if (!ref) return window.location.href;
  return base + "?ref=" + ref;
};

export const deleteRefUrlCookie = () => {
  setCookie({
    name: REF_URL_COOKIE_NAME,
    value: "",
    daysToLiveInDays: -1,
  });
};

export const getResolvedRefRedirectUrl = (origin, opts = {}) => {
  const ref = getRefUrlCookie();
  if (!ref) return null;
  const base =
    origin != null
      ? origin
      : typeof window !== "undefined"
      ? window.location.origin
      : "";
  try {
    const refUrl = new URL(ref, base);
    const pathname = refUrl.pathname || "/";
    if (opts.keepQuery && refUrl.search) {
      return base + pathname + refUrl.search;
    }
    return base + pathname;
  } catch {
    return ref;
  }
};

// Run on page load: store ref_url when URL has campaign params in ?query OR
// in #hash. Don't set for path-only URLs. Keep 15 days.
export const initRefUrlOnPageLand = () => {
  if (typeof window === "undefined") return;
  const landingUrl = window.location.href;
  const pathname = window.location.pathname || "/";
  const hasQueryInSearch = !!window.location.search;
  const hasQueryInHash =
    !!window.location.hash && window.location.hash.indexOf("?") !== -1;
  const hasCampaignParams = hasQueryInSearch || hasQueryInHash;
  const isRegisterPage =
    pathname === "/register" || pathname.endsWith("/register");
  const storedUrl = getRefUrlCookie();

  if (hasCampaignParams && !isRegisterPage && landingUrl !== storedUrl) {
    setRefUrlCookie(landingUrl);
  }

  const url = new URL(landingUrl);
  let changed = false;
  if (url.searchParams.has("ref")) {
    url.searchParams.delete("ref");
    changed = true;
  }
  let newHash = url.hash;
  if (url.hash && url.hash.startsWith("#ref=")) {
    newHash = "";
    changed = true;
  }
  if (changed) {
    const newUrl =
      url.origin + url.pathname + (url.search || "") + newHash;
    window.history.replaceState({}, "", newUrl);
  }
};

// Auto-run when module loads in browser
if (typeof window !== "undefined") {
  initRefUrlOnPageLand();
}
